// These should always match the version in package.json in the repo root
export const PACKAGE_MAJOR_VERSION = 0;
export const PACKAGE_MINOR_VERSION = 0;
export const PACKAGE_BUGFIX_VERSION = 0;
export const DEFAULT_WALL_HEIGHT = 3;
export const DEFAULT_WIDTH = 8;
export const DEFAULT_DEPTH = 4;
